import React, { FC, ReactNode } from "react";
import styles from "./ErrorMessage.module.css";
import Colors from "ui-kit/colors";

type ErrorMessageType = {
  severity?: "warning" | "error";
  children: ReactNode;
};

const ErrorMessage: FC<ErrorMessageType> = ({
  severity = "error",
  children,
}) => {
  return (
    <div className={styles.container}>
      <div
        className={styles.message}
        style={
          severity === "warning"
            ? {
                backgroundColor: `${Colors.orange100}88`, //50 % opacity
              }
            : { backgroundColor: Colors.errorBg }
        }
      >
        {children}
      </div>
    </div>
  );
};

export default ErrorMessage;
